import { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

export default function TechNewsPage() {
  const [news, setNews] = useState([]);
  const [error, setError] = useState(null);

  // فیلتر و سورت
  const [searchText, setSearchText] = useState('');
  const [categoryFilter, setCategoryFilter] = useState('');
  const [categories, setCategories] = useState([]);
  const [sortField, setSortField] = useState('date'); // 'title' یا 'date'
  const [sortOrder, setSortOrder] = useState('desc'); // 'asc' یا 'desc'

  // صفحه‌بندی
  const [pageSize, setPageSize] = useState(6);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get('/api/admin/news', { withCredentials: true });
        setNews(Array.isArray(data) ? data : data.news || []);
      } catch {
        setError('Error fetching news');
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get('/api/categories');
        setCategories(data);
      } catch {
        console.error('Error fetching categories');
      }
    })();
  }, []);

  if (error) return <div className="alert alert-danger">{error}</div>;

  // اعمال فیلتر و سورت
  let filtered = [...news];

  if (searchText) {
    filtered = filtered.filter(n =>
      n.title.toLowerCase().includes(searchText.toLowerCase()) ||
      n.summary?.toLowerCase().includes(searchText.toLowerCase())
    );
  }

  if (categoryFilter) {
    filtered = filtered.filter(n => n.category === categoryFilter);
  }

  filtered.sort((a, b) => {
    if (sortField === 'title') {
      return sortOrder === 'asc'
        ? a.title.localeCompare(b.title)
        : b.title.localeCompare(a.title);
    } else {
      return sortOrder === 'asc'
        ? new Date(a.createdAt) - new Date(b.createdAt)
        : new Date(b.createdAt) - new Date(a.createdAt);
    }
  });

  // صفحه‌بندی
  const totalPages = Math.ceil(filtered.length / pageSize);
  const startIndex = (currentPage - 1) * pageSize;
  const currentItems = filtered.slice(startIndex, startIndex + pageSize);

  return (
    <div className="container py-5">
      <h1 className="h4 mb-4">Latest Tech News</h1>

      {/* کنترل‌ها */}
      <div className="d-flex flex-wrap gap-3 mb-4">
        <input
          type="text"
          className="form-control"
          placeholder="Search..."
          value={searchText}
          onChange={e => setSearchText(e.target.value)}
          style={{ maxWidth: '200px' }}
        />

        <select
          className="form-select"
          value={categoryFilter}
          onChange={e => setCategoryFilter(e.target.value)}
          style={{ maxWidth: '200px' }}
        >
          <option value="">All Categories</option>
          {categories.map(c => (
            <option key={c._id} value={c.name}>{c.name}</option>
          ))}
        </select>

        <select
          className="form-select"
          value={pageSize}
          onChange={e => setPageSize(Number(e.target.value))}
          style={{ maxWidth: '120px' }}
        >
          {[3, 6, 9, 12, 15].map(size => (
            <option key={size} value={size}>{size} per page</option>
          ))}
        </select>

        <select
          className="form-select"
          value={sortField}
          onChange={e => setSortField(e.target.value)}
          style={{ maxWidth: '150px' }}
        >
          <option value="date">Sort by Date</option>
          <option value="title">Sort by Title</option>
        </select>

        <select
          className="form-select"
          value={sortOrder}
          onChange={e => setSortOrder(e.target.value)}
          style={{ maxWidth: '150px' }}
        >
          <option value="asc">Ascending</option>
          <option value="desc">Descending</option>
        </select>
      </div>

      {/* لیست کارت‌ها */}
      <div className="row g-4">
        {currentItems.map(n => (
          <div key={n._id} className="col-md-4">
            <div className="card h-100 shadow-sm">
              {n.thumbnailUrl && (
                <img
                    src={n.thumbnailUrl}
                    className="card-img-top"
                    alt={n.title}
                    style={{ height: '200px', objectFit: 'cover' }}
                  />
              )}    
              <div className="card-body d-flex flex-column">
                <h5 className="card-title">{n.title}</h5>
                <p className="card-text">{n.summary}</p>
                <p className="text-muted mb-2">
                  Average rating: {n.averageRating?.toFixed(1) || 0} ★
                </p>
                <small className="text-muted">
                  {new Date(n.createdAt).toLocaleDateString()}
                </small>
                <Link to={`/news/${n._id}`} className="btn btn-primary btn-sm mt-auto">
                  Read More
                </Link>
              </div>
            </div>
          </div>
        ))}
        {currentItems.length === 0 && (
          <p className="text-muted">No news available</p>
        )}
      </div>

      {/* صفحه‌بندی */}
      <nav className="mt-4">
        <ul className="pagination justify-content-center">
        {/* دکمه Previous */}
        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
          <button
            className="page-link"
            onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
          >
          Previous
          </button>
        </li>

        {/* شماره صفحات */}
        {Array.from({ length: totalPages }, (_, i) => (
          <li key={i} className={`page-item ${currentPage === i + 1 ? 'active' : ''}`}>
            <button className="page-link" onClick={() => setCurrentPage(i + 1)}>
              {i + 1}
          </button>
          </li>
        ))}

        {/* دکمه Next */}
          <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
              <button
                className="page-link"
                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
              >
              Next
            </button>
          </li>
        </ul>
    </nav>
    </div>
  );
}
